module.exports = __webpack_public_path__ + "img/17-5-en.e9aab654.png";